/**
 * Formats any positive or negative string/number value into US Dollar as a string
 * @param {string | number} value - string or number to convert to currency
 */
const formatCurrency = (value) => {
    /**
     *These extra calculations were done because when the value was negative
     *  the NumberFormat function was not working as expected in IE
     */
    const prefix = value < 0 ? '-' : '';
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    });
    const formattedNumber = formatter.format(Math.abs(Number(value)));
    return `${prefix}${formattedNumber}`;
};
export default formatCurrency;
